import { IPopover } from '@shared/models/popover';

export const jobDescriptionPopOver: IPopover = {
	triggerText: {
		desktop: "What's this?",
		mobile: "What's this?",
	},
	title: 'Job Description',
	description: 'Explains the work to be done. Shown to the team and the client on the job card.',
	icon: 'bi-info-circle-fill',
};

export const internalNotesPopOver: IPopover = {
	triggerText: {
		desktop: "What's this?",
		mobile: "What's this?",
	},
	title: 'Additional Internal Notes',
	description: 'Share info the team needs on-site. Not visible to the client.',
	icon: 'bi-info-circle-fill',
};
